module.exports = __webpack_public_path__ + "media/newstyle/images/bb-fa1673108e06c29af0f31a73c947a168.svg";